const colors = {
    white1: '#e6e6e6',
    white2: '#8a99a3',
    white3: '#606f7b',
    white4: '#9da9b2',
    dark1: '#181c1f',
    dark2: '#39424c',
    dark3: '#333b44',
    dark4: '#262c31',
    dark5: '#444e5a',
    // ---------------------------------------------------------
    lightWhite0: 'white',
    lightWhite1: '#c0cddf',
    lightWhite2: '#ebeef2',
    lightWhite3: '#e5f0fc',
    lightWhite4: '#f2f2f2',
    lightWhite5: '#606f7b',
    lightWhite6: '#9da9b2',
    lightDark1: '#2a2a2a',
    lightDark2: 'grey',
    // ---------------------------------------------------------

    blueWhite1: '#e2e8f0',
    blueWhite2: '#dfecfb',
    blueWhite3: 'white',
    blueWhite4: '#e5f0fc',
    blueDark1: '#0e3867',
};

const common = {
    bodyBackground: colors.dark2,
    table: {
        border: {
            background: colors.dark2,
        },
        header: {
            background: colors.dark1,
            color: colors.white1,
        },
        body: {
            background: colors.dark4,
            row: {
                background: colors.dark5,
                name: {
                    color: colors.white4,
                },
                type: {
                    color: colors.white3,
                },
            },
        },
        nested: {
            background: colors.dark3,
            color: colors.white1,
            row: {
                name: {
                    color: colors.white2,
                },
                type: {
                    color: colors.white3,
                },
            },
        },
    },
};

const light = {
    ...common,
    body: {
        background: colors.dark2,
    },
    table: {
        shadow: {
            color: 'rgba(0, 0, 0, 0.15)', // canvas
        },
        border: {
            background: colors.dark2,
        },
        header: {
            background: 'white',
            // color: colors.white1, // common
            // color: '#7f92a5',
            // color: colors.white4,

            // color: '#acb6be', // html
            color: '#182955', // canvas

            border: '#dde4ea', // canvas / bottom border
        },
        body: {
            background: 'white', // light // // table background and border colors
            row: {
                background: colors.dark5,
                hover: {
                    background: '#ebf4fd',
                },
                name: {
                    // color: colors.white4, // html
                    color: '#182955', // canvas
                },
                type: {
                    // color: colors.white3, // html
                    color: '#8a99a3', // canvas
                },
            },
        },
        nested: {
            background: colors.dark3,
            color: colors.white1,
            row: {
                name: {
                    color: colors.white2,
                },
                type: {
                    color: colors.white3,
                },
            },
        },
        indexes: {
            // darker on 12% than dark theme
            regular: '#61bee5', // sky blue
            unique: '#dd698a', // pink
            composite: '#FFA500', // orange
            fullText: '#3bbb66', // light green
        },
    },
    controls: {
        background: '#262c31',
        color: '#ffffff',
        button: {
            background: '#262c31',
            hover: {
                background: '#444e5a',
            },
            select: {
                background: '#bedaf8',
            },
        },
    },
    relationLineStroke: '#bcc6d3',
    logo: {
        color: '#acb6be',
    },
    changeRequests: {
        base: {
            color: {
                red: '#861a2a', // base red
                green: '#27c68a', // base green
            },
        },
        table: {
            head: {
                background: {
                    red: '#4d0e18', // #490d17 - darker
                    green: '#0b3929', // #093021 - darker
                    redDarker: '#360a11', // darken red - on 60%
                    greenDarker: '#062016', // darken green - on 84%
                },
            },
            body: {
                background: {
                    red: '#5c111d', // #58111b - darker
                    green: '#0e4632',
                    redDarker: '#4a0e17', // darken red - on 45%
                    greenDarker: '#0a3122', // darken green - on 75%
                    new: '#23282d',
                },
                hover: {
                    base: '#31393f',
                    red: '#6a1421',
                    green: '#0f5037',
                },
                text: {
                    background: {
                        red: '#951d2f',
                        green: '#157652',
                        redDarker: '#861a2a', // default
                        greenDarker: '#075e29', // default ? // #0d5c3e - darken green - on 31%
                    },
                },
                changes: {
                    text: {
                        color: 'white',
                    },
                },
            },
        },
    },
};

const dark = {
    ...common,
    body: {
        background: colors.dark2,
    },
    table: {
        shadow: {
            color: 'rgba(0, 0, 0, 0.25)', // canvas
        },
        border: {
            background: colors.dark2,
        },
        header: {
            // background: colors.dark1,

            background: '#0d0e10',
            // background: 'black',


            // backgroundGreen: '#0b3929',
            // backgroundRed: '#4d0e18',
            // background: '#0b3929',

            // color: colors.white1, // common
            // color: '#7f92a5', // was commented
            // color: colors.white4, // was commented
            // color: '#acb6be', // html // canvas

            // color: '#b8c1c8', // html // // ASAP LAST
            color: '#C0CCD8', // html // canvas
            color: '#d5e0eb', // html // canvas
            color: '#c3d3e3', // html // canvas
            color: 'rgba(195, 211, 227, 1)', // html // canvas
            color: 'rgba(195, 211, 220, 1)', // html // canvas
            color: 'rgba(195, 211, 218, 1)', // html // canvas
            color: 'rgba(197, 213, 220, 1)', // html // canvas

            color: 'rgba(198, 214, 221, 1)', // html // canvas
            color: 'rgba(199, 215, 222, 1)', // html // canvas

            // color: '#bdc5cb', // html // canvas

            // border: colors.dark2, // canvas / bottom border
            border: '#3f4955', // colors.dark2 + 4%
        },
        body: {
            // background: colors.dark4,
            // background: colors.dark4,

            background: '#252b30',
            background: 'rgba(37, 43, 49, 1)',
            background: 'rgba(36, 42, 49, 1)',
            // background: 'rgba(37, 41, 48, 1)',
            // background: 'rgba(39, 43, 50, 1)',
            // background: 'rgba(32, 36, 44, 1)',
            // background: 'rgba(34, 38, 46, 1)',
            // background: 'rgba(34, 38, 44, 1)',

            // background: '#242730ff',
            // background: '#21272b',

            // background: 'rgba(36, 43, 51, 1)',


            // background: '#1e2328',
            // backgroundGreen: '#0e4632',
            // backgroundRed: '#5c111d',
            // background: '#5c111d',


            // background: "#21272b",

            row: {
                background: colors.dark5,
                hover: {
                    background: '#31393f', //'#2f373d',
                    // backgroundGreen: '#0f5037', //'#2f373d',
                    // backgroundRed: '#6a1421', //'#2f373d',
                    // background: '#6a1421', //'#2f373d',
                },
                name: {
                    // color: colors.white4,
                    // color: '#acb6be',
                    // color: '#a7b2ba',

                    // color: '#a2adb6', // ASAP LAST
                    // color: '#abb5bd',
                    // color: '#b2bbc2',
                    color: '#b5bec5',
                    color: 'rgba(183, 192, 199, 1)',
                    color: 'rgba(195, 211, 218, 1)', // html // canvas

                    color: 'rgba(196, 212, 219, 1)', // html // canvas
                    color: 'rgba(197, 213, 220, 1)', // html // canvas
                    // color: 'rgba(198, 214, 221, 1)', // html // canvas
                    // color: 'rgba(199, 215, 222, 1)', // html // canvas

                    // color: '#c3d3e3',
                    // color: '#b6c2cc',
                    // color: '#b8c1c8',


                    // color: '#bbc2ca',
                    // color: '#bcc4cb',
                    // color: '#c0c7ce',

                },
                type: {
                    // color: '#71828f',
                    // color: colors.white3,

                    // color: '#63717d', // ASAP LAST
                    // color: '#707D89',
                    color: '#7b8793',
                    color: '#7b8a9aff',
                    color: 'rgba(123, 138, 150, 1)',

                    // color: '#85919e',



                    // color: '#85909b',
                },
            },
        },
        nested: {
            background: colors.dark3,
            color: colors.white1,
            row: {
                name: {
                    color: colors.white2,
                },
                type: {
                    color: colors.white3,
                },
            },
        },
        indexes: {
            regular: '#87CEEB', // sky blue
            // unique: '#e66f9eff', // pink
            unique: '#e16999ff', // pink
            composite: '#FFA500', // orange
            // fullText: '#50C878', // light green
            fullText: '#50c888ff', // light green



            // unique: '#87CEEB', // pink
            // fullText: '#87CEEB', // light green

        },
    },
    controls: {
        // background: '#262c31',
        background: '#1c2125',
        color: '#ffffff',
        button: {
            // background: '#262c31',
            background: '#1c2125',
            hover: {
                background: '#444e5a',
            },
            select: {
                background: '#bedaf8',
            },
        },
    },
    relationLineStroke: '#bcc6d3',
    logo: {
        color: '#acb6be',
    },
    changeRequests: {
        base: {
            color: {
                red: '#861a2a', // base red
                green: '#27c68a', // base green
            },
        },
        table: {
            head: {
                background: {
                    red: '#4d0e18', // #490d17 - darker
                    green: '#0b3929', // #093021 - darker
                    redDarker: '#360a11', // darken red - on 60%
                    greenDarker: '#062016', // darken green - on 84%
                },
            },
            body: {
                background: {
                    red: '#5c111d', // #58111b - darker
                    green: '#0e4632',
                    redDarker: '#4a0e17', // darken red - on 45%
                    greenDarker: '#0a3122', // darken green - on 75%
                    new: '#23282d',
                },
                hover: {
                    base: '#31393f',
                    red: '#6a1421',
                    green: '#0f5037',
                },
                text: {
                    background: {
                        red: '#951d2f',
                        green: '#157652',
                        redDarker: '#861a2a', // default
                        greenDarker: '#075e29', // default ? // #0d5c3e - darken green - on 31%
                    },
                },
                changes: {
                    text: {
                        color: 'white',
                    },
                },
            },
        },
    },
};

const themes = { light, dark };
export { themes };
